import { useNavigate } from "react-router-dom";
import MeaPage from "../../../components/MeaPage";
import { useRef } from "react";
import SecretariatWorkspaceBar from "../components/SecretariatWorkspaceBar";
import { useAuthContext } from "../../../hooks/useAuthContext";
import TrainingsListComponent from "../components/TrainingsListComponent";
import MeaPermissionGuard from "../../../components/MeaPermissionGuard";
import { PERMISSION_TRAINING_TEACHERS } from "../../../permissions";

const SecretariatTeachersListPage = () => {
  const { currentMembership } = useAuthContext();
  const navigate = useNavigate();
  const listRef = useRef();

  return (
    <MeaPermissionGuard
      permission={PERMISSION_TRAINING_TEACHERS.LIST}
      fallbackTo={`/school/${currentMembership?.school?.id}/secretariat`}
    >
      <MeaPage
        title="De quelle formation ?"
        breadcrumb={<SecretariatWorkspaceBar section="teachers" />}
        showBackButton={true}
        onBackButtonClick={() => navigate(`/school/${currentMembership?.school?.id}/secretariat`)}
      >
        <TrainingsListComponent
          ref={listRef}
          showAddButton={false}
          redirectPath="teachers"
        />
      </MeaPage>
    </MeaPermissionGuard>
  );
};

export default SecretariatTeachersListPage;
